var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 21a1.93 1.93 0 01-1.413-.587A1.928 1.928 0 013.5 19v-4h2v4h14V5h-14v4h-2V5c0-.55.196-1.021.587-1.413A1.928 1.928 0 015.5 3h14c.55 0 1.021.196 1.413.587.391.392.587.863.587 1.413v14a1.93 1.93 0 01-.587 1.413A1.928 1.928 0 0119.5 21h-14z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 17l1.4-1.45L8.85 13h8.65v-2H8.85l2.55-2.55L10 7l-5 5 5 5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogout);
export default __webpack_public_path__ + "static/media/icon_logout.466d9b2b4d8d53fd8a1e368012f50f35.svg";
export { ForwardRef as ReactComponent };